export class LayaEnv {
}
LayaEnv.version = "3.3.1";
LayaEnv.isPlaying = true;
LayaEnv.isPreview = false;
LayaEnv.isConch = window ? (window.conch != null) : false;
LayaEnv.isEditor = false;
